import Model from './Model';

export default class Distribution extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'distribution';
  }
}
